<template>
<div style="background: white; ">
    <div class="row filter-row">
        <!--<div class="col">
            <!--<status-toggle
                :options="currentStatusOptions"
                :value="$route.params.filter"
                @input="filterChanged"
                style="margin: .5rem 0"
            />
        </div>!-->
        <div class="col">
            <message-list-sort-order
                @input="filtersChanged"
            />
        </div>
        <div class="col text-right" style="padding-top: .45rem;">
            <div v-if="hasResults">
                <span style="vertical-align: middle;">{{ results.from }} - {{ results.to }} of {{ results.total }}</span>
                <ui-icon-button :disabled="!hasPreviousPages" @click="previous" size="mini" type="secondary" icon="chevron_left" style="vertical-align: middle;"></ui-icon-button>
                <ui-icon-button :disabled="!hasMorePages" @click="next" size="mini" type="secondary" icon="chevron_right" style="vertical-align: middle;"></ui-icon-button>
            </div>
        </div>
    </div>

    <loading-pane v-if="isBusy" />
    <div v-else-if="hasResults">
        <div :class="['row', 'align-items-center', 'message-row', 'header-row', { 'scrolling': !atScrollTop }]">
            <div class="col bulk-select-column">
                <ui-checkbox v-model="checkedStatus" />
            </div>
            <div class="col-9">
                Customer
            </div>
            <div v-if="!isMineView" class="col">
                Assigned To
            </div>
            <div class="col text-right">
                Waiting For
            </div>
            <div v-if="isMineView" class="col status-column"></div>
        </div>
        <div @scroll="scrollMonitor" style="overflow-y: auto; overflow-x: hidden; height: calc(100vh - 200px);">
            <div v-for="(conversation, index) in results.results" :key="conversation.id" class="row align-items-center message-row">
                <div class="col bulk-select-column">
                    <ui-checkbox v-model="selected[conversation.id]" />
                </div>
                <div class="col-9" @click="showConversation(conversation)">
                    <strong>{{ conversation.contact.primary_display_as }}</strong>
                    <div v-if="conversation.latest_message" style="font-weight: 500; color: #999;">
                        <span v-for="tag in conversation.tags" class="tag">{{ tag.name }}</span>
                        {{ conversation.latest_message.subject }}
                    </div>
                    <div v-if="conversation.latest_message" class="message-preview">
                        <div>{{ conversation.latest_message.preview }}</div>
                    </div>
                    <div v-if="conversation.message_count > 1" style="position: absolute; right: 0; top: 50%; transform: translateY(-50%)">
                        <span class="badge badge-secondary">{{ conversation.message_count }}</span>
                    </div>
                </div>
                <div v-if="!isMineView" class="col">
                    <avatar-group :users="conversation.assignees" />
                </div>
                <div class="col text-right">
                    <strong>{{ conversation.last_action_at | waitingSince }}</strong>
                </div>
                <div v-if="isMineView" class="col status-column">
                    <div v-if="conversation.status === 'waiting'" style="width:12px;height: 12px; background: #2196f3; margin: auto; border-radius: 50%;"></div>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="text-center" style="min-height: calc(100vh - 210px); display: flex;">
        <div style="align-self: center; margin: 0 auto 7rem;">
            <img @click="$refs.copyright.open()" style="width: 500px; margin: auto; display: block;" src="https://upload.wikimedia.org/wikipedia/commons/b/b4/Paper_Plane_Vector.svg" />
            <h1 style="font-weight: normal; margin-top: 2rem;">Nothing Here!</h1>
            <p style="color: #999;">You crushed it</p>
            <div style="position:absolute; right: 10px; bottom: 10px;">
                <span class="material-icons" @click="$refs.copyright.open()">info_outline</span>
                <ui-popover ref="copyright" open-on="manual">
                    <div style="padding: 1rem">
                        <a target="_blank" href="https://commons.wikimedia.org/wiki/File:Paper_Plane_Vector.svg##" title="File:Paper Plane Vector.svg">Paper Plane Vector.svg</a> from <a target="_blank" href="https://commons.wikimedia.org/wiki/Main_Page" title="Main Page">Wikimedia Commons</a> by <a target="_blank" rel="nofollow" class="external text" href="https://videoplasty.com/">Videoplasty.com</a>,<a target="_blank" rel="nofollow" class="external text" href="https://creativecommons.org/licenses/by-sa/4.0/deed.en">CC-BY-SA 4.0</a>
                    </div>
                </ui-popover>
            </div>
        </div>
    </div>

    <bulk-menu
        :selected="selectedItems"
        @changed="unselect(); load()"
    />
</div>
</template>

<script>
    import DataView from '../mixins/DataView'
    import {ConversationResource, ConversationStatuses} from '../../classes/Api/Inbox'
    import {InboxFilters} from "./filters";
    import Filters from "../../filters"
    import AvatarGroup from "../elements/AvatarGroup";
    import LoadingPane from "./LoadingPane";
    import StatusToggle from "./MessageListStatusToggle";
    import MessageListSortOrder from "./MessageListSortOrder";
    import BulkMenu from "./BulkMenu";
    import {find} from 'lodash'
    import DataViewSelection from "../mixins/DataViewSelection";

    const myStatusOptions = [
        {
            value: 'open',
            label: 'Open',
        },
        {
            value: 'closed',
            label: 'Closed',
        },
        {
            value: 'bin',
            label: 'Bin',
        }
    ]

    const overdueOptions = [
        {
            value: 'unassigned',
            label: 'Unassigned',
        },
        {
            value: 'open',
            label: 'Open',
        }
    ]

    const inboxStatusOptions = [
        {
            value: 'unassigned',
            label: 'Unassigned',
        },
        {
            value: 'open',
            label: 'Open',
        },
        {
            value: 'closed',
            label: 'Closed',
        },
        {
            value: 'bin',
            label: 'Bin',
        }
    ]

    let loadDelay;

    export default {
        components: {BulkMenu, MessageListSortOrder, StatusToggle, AvatarGroup, LoadingPane },
        mixins: [DataView, DataViewSelection],
        filters: { ...InboxFilters, ...Filters },
        created() {
            this.setResourceRelations([
                'contact',
                'assignedUsers',
                'latestMessage',
            ])

            this.setPerPage(100)

            this.applyRouteFilters(this.$route, false);

            this.setResourceAndLoad(ConversationResource)

            this.$root.$on('notification', (notification) => {
                if (notification.data.type === 'inbox.reply.received' ||
                    notification.data.type === 'inbox.new.conversation' ||
                    notification.data.type === 'inbox.conversation.assigned') {
                    this.load()
                }
            })
        },
        data() {
            return {
                atScrollTop: true,
                sortOrder: {
                    label: 'Newest',
                    value: 'last_action DESC'
                },
                selectedFilters: {
                    'conversation.team_member': '%',
                    'conversation.status': '%',
                }
            }
        },
        watch: {
            $route(to, from) {
                if (to !== from) {
                    this.applyRouteFilters(to);
                }
            }
        },
        methods: {
            next() {
                this.$store.dispatch('dataView/next')
            },
            previous() {
                this.$store.dispatch('dataView/previous')
            },
            scrollMonitor(e) {
                this.atScrollTop = e.target.scrollTop < 5;
            },
            setSortOrder(order) {
              this.sortOrder = order
            },
            applyRouteFilters(route, load = true) {
                //this.selectedFilters['conversation.lead_presence'] = '0'

                if (route.params.message_box_id === 'mine') {
                    this.selectedFilters['conversation.team_member'] = window.marque.ui.user.id
                    this.selectedFilters['conversation.status'] = [
                        ConversationStatuses.STATUS_WAITING,
                        ConversationStatuses.STATUS_FOLLOW_UP
                    ]
                } else if (find(ConversationStatuses, s => s === route.params.message_box_id)) {
                    this.selectedFilters['conversation.team_member'] = '%'
                    this.selectedFilters['conversation.status'] = route.params.message_box_id
                } else {
                    this.selectedFilters['conversation.team_member'] = '%'
                    this.selectedFilters['conversation.status'] = '%'
                }

                this.setPage(1)

                this.filtersChanged(load)
            },
            filtersChanged(load = true) {
                this.setFilters(this.selectedFilters)

                if (load) {
                    this.load()
                }
            },
            showConversation(conversation) {
                this.$router.push('/inbox/' + conversation.message_box_id + '/conversations/' + conversation.id)
            },
            filterChanged(filter) {
                this.$router.push('/inbox/' + this.$route.params.message_box_id + '/' + filter.value)
            }
        },
        computed: {
            isMineView() {
                return this.$route.params.message_box_id === 'mine'
            },
            currentStatusOptions() {
              if (this.$route.params.message_box_id === 'mine') {
                  return myStatusOptions
              } else if (this.$route.params.message_box_id === 'overdue') {
                  return overdueOptions
              }

              return inboxStatusOptions
            }
        }
    }
</script>

<style scoped lang="scss">
  .filter-row {
    padding: .5rem 1rem;
    color: #aaa;
    font-size: .8rem;

    a, a:link { color: #999; }
  }

  .message-row {
    padding: 1rem;
    border-top: 1px solid #eee;
      cursor: pointer;

    &.header-row {
      color: #999;
      padding: 0.5rem 1rem;

        &.scrolling {
            box-shadow: 1px 5px 14px -10px rgb(0 0 0 / 25%);
        }
    }

    .bulk-select-column {
      max-width: 50px;
      .ui-checkbox { margin-bottom: 0; }
    }

      .status-column {
          max-width: 50px;
          text-align: center;
      }

    .message-preview {
        position: relative;
        color: #999;
        font-size: .9rem;
        white-space: nowrap;
        overflow: hidden;
        max-width: 100%;
        height: 1.5rem;
        div {
            position: absolute;
            left: 0;
        }
        &:after {
            position: absolute;
            right: 0;
            top: 0;
            content: " ";
            width: 120px;
            height: 100%;
            background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAABCAYAAAAVSWrbAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFBmlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNi4wLWMwMDYgNzkuMTY0NzUzLCAyMDIxLzAyLzE1LTExOjUyOjEzICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgMjIuMyAoTWFjaW50b3NoKSIgeG1wOkNyZWF0ZURhdGU9IjIwMjItMDEtMjJUMTU6MDk6MjhaIiB4bXA6TW9kaWZ5RGF0ZT0iMjAyMi0wMS0yMlQxNTowOTo0M1oiIHhtcDpNZXRhZGF0YURhdGU9IjIwMjItMDEtMjJUMTU6MDk6NDNaIiBkYzpmb3JtYXQ9ImltYWdlL3BuZyIgcGhvdG9zaG9wOkNvbG9yTW9kZT0iMyIgcGhvdG9zaG9wOklDQ1Byb2ZpbGU9InNSR0IgSUVDNjE5NjYtMi4xIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjJkZjhhMjI2LTVjMWEtNGM5OC1iM2Q2LWQzNDljZjRiNWI5ZCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoyZGY4YTIyNi01YzFhLTRjOTgtYjNkNi1kMzQ5Y2Y0YjViOWQiIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDoyZGY4YTIyNi01YzFhLTRjOTgtYjNkNi1kMzQ5Y2Y0YjViOWQiPiA8eG1wTU06SGlzdG9yeT4gPHJkZjpTZXE+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJjcmVhdGVkIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOjJkZjhhMjI2LTVjMWEtNGM5OC1iM2Q2LWQzNDljZjRiNWI5ZCIgc3RFdnQ6d2hlbj0iMjAyMi0wMS0yMlQxNTowOToyOFoiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCAyMi4zIChNYWNpbnRvc2gpIi8+IDwvcmRmOlNlcT4gPC94bXBNTTpIaXN0b3J5PiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PguZq+8AAABNSURBVBiVfZHRCgBQBEPn+v9vdl+opc3DwmFRoqoCQAB4HdGR2WthMe5xrmqnmcsW+9Lkjqn5i+Xa73zqvmu3E/tDeFRP/YIZ18PmT/hungPiyQGPrQAAAABJRU5ErkJggg==);
            background-size: contain;
        }
    }
  }
</style>